import Modal from "react-bootstrap/Modal";
import { styleEnd, styleStart } from "../../algorithms/styleDirection";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import Lang from "../../userPreferences/staticWords";
import moment from "moment";
import "moment/locale/ar";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";

const DetailsPopup = (props) => {
  const { onHide, name, content } = props;

  useEffect(() => {
    if (Lang.getLanguage() === "ar") moment.locale("ar");
    else moment.locale("en");
  }, []);

  return (
    <Modal
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      {...props}
      style={{ zIndex: 1000000 }}
      backdrop="static"
    >
      <Modal.Header
        style={{ direction: getDir(getCurrentLangFromRedux()) }}
        className="pb-0"
      >
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="d-flex align-items-center">
            <div
              className="mx-2 d-flex justify-content-center align-items-center"
              style={{
                height: 32,
                width: 32,
              }}
            >
              <div className="d-flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="35.154"
                  height="35.314"
                  viewBox="0 0 44.154 40.314"
                >
                  <g
                    id="Group_304"
                    data-name="Group 304"
                    transform="translate(-465.846 -383.686)"
                  >
                    <g
                      id="_007-layers"
                      data-name="007-layers"
                      transform="translate(465.846 383.686)"
                    >
                      <path
                        id="Path_163"
                        data-name="Path 163"
                        d="M17.837,31.291a9.46,9.46,0,0,1-4.71-1.266L2.493,23.937a5.2,5.2,0,0,1,.024-8.894L13.178,9.026a9.4,9.4,0,0,1,9.318,0l10.661,6.018a5.2,5.2,0,0,1,.024,8.894L22.547,30.025a9.462,9.462,0,0,1-4.71,1.266Zm0-20.526a6.814,6.814,0,0,0-3.356.89L3.82,17.673a2.129,2.129,0,0,0-.01,3.644L14.444,27.4a6.766,6.766,0,0,0,6.785,0l10.634-6.087a2.129,2.129,0,0,0-.01-3.644L21.193,11.655A6.815,6.815,0,0,0,17.837,10.765ZM13.83,10.34h0Zm8.717,33.143L34.938,36.39a1.539,1.539,0,0,0,.569-2.013,1.35,1.35,0,0,0-1.887-.608L21.229,40.862a6.768,6.768,0,0,1-6.79,0L2.048,33.84a1.351,1.351,0,0,0-1.884.616,1.538,1.538,0,0,0,.578,2.011l12.386,7.015a9.393,9.393,0,0,0,9.42,0Zm0-6.692L34.938,29.7a1.539,1.539,0,0,0,.569-2.013,1.35,1.35,0,0,0-1.887-.608L21.229,34.17a6.768,6.768,0,0,1-6.79,0L2.048,27.148a1.351,1.351,0,0,0-1.884.616,1.538,1.538,0,0,0,.578,2.011l12.386,7.015a9.393,9.393,0,0,0,9.42,0Z"
                        transform="translate(-0.001 -7.79)"
                        fill="#12aac4"
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <div className="text-dark">
              <p
                className="my-0 mx-2"
                style={{ fontSize: 20, textAlign: "justify" }}
              >
                {name}
              </p>
            </div>
          </div>
        </Modal.Title>
        <div className={`d-flex justify-content-end mt-2 ${styleEnd("m", 3)}`}>
          <Icon
            name="times"
            size={22}
            color={"#1A73E8"}
            onclick={() => {
              onHide();
            }}
          />
        </div>
      </Modal.Header>
      <Modal.Body
        style={{ direction: getDir(getCurrentLangFromRedux()) }}
        className={`${styleStart("p", 5)}`}
      >
        {/* date */}
        <div className="d-flex align-items-center px-4">
          <p className="text-muted" style={{ fontSize: 14 }}>
            {Lang.inPeriod}
            <span>
              &nbsp;&nbsp;&nbsp;{Lang.from}{" "}
              {`${moment(new Date(content.startDate)).format("LL")}`}
            </span>{" "}
            <span>
              &nbsp;&nbsp;&nbsp;{Lang.to}{" "}
              {`${moment(new Date(content.endDate)).format("LL")}`}
            </span>
          </p>
        </div>

        {/* icons */}
        <div className="d-flex flex-wrap align-items-center px-4 py-2">
          <div
            className={`d-flex justify-content-center py-2 px-3 ${styleEnd(
              "m",
              2
            )} mb-2`}
            style={{
              backgroundColor: "#F2F2F2",
              width: "fit-content",
              borderRadius: 10,
            }}
          >
            <div className={`${styleEnd("m", 2)}`}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16.883"
                height="18"
                viewBox="0 0 16.883 18"
              >
                <path
                  id="_001-clock"
                  data-name="001-clock"
                  d="M8.442,18.25C.949,18.242-2.821,8.53,2.473,2.871a8.107,8.107,0,0,1,11.938,0C19.7,8.531,15.934,18.242,8.442,18.25Zm0-16.61a7.382,7.382,0,0,0-7.123,7.6c.391,10.084,13.855,10.081,14.245,0A7.382,7.382,0,0,0,8.442,1.64Zm3.071,9.884L9.429,9.3A1.092,1.092,0,0,0,9.1,8.454c0-.007,0-.015,0-.022V4.314a.661.661,0,1,0-1.319,0V8.432c0,.007,0,.015,0,.022A1.066,1.066,0,0,0,8.5,10.3l2.084,2.224a.631.631,0,0,0,.933,0,.738.738,0,0,0,0-1Z"
                  transform="translate(0 -0.25)"
                  fill={content?.dayCount?.color ?? "#3ec4b8"}
                />
              </svg>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <p className="my-0">
                {content?.dayCount?.day >= 0 ? content.dayCount.day : ""}&nbsp;
                {content?.dayCount?.daystatus}
              </p>
            </div>
          </div>

          <div
            className={`d-flex justify-content-center py-2 px-3 ${styleEnd(
              "m",
              2
            )} mb-2`}
            style={{
              backgroundColor: "#F2F2F2",
              width: "fit-content",
              borderRadius: 10,
            }}
          >
            <div className={`${styleEnd("m", 2)}`}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
              >
                <g
                  id="technical-support_1_"
                  data-name="technical-support (1)"
                  transform="translate(0 0.001)"
                >
                  <path
                    id="Path_428"
                    data-name="Path 428"
                    d="M3.165,13.919a1.468,1.468,0,0,0-.709.181A8.3,8.3,0,0,1,10.652.867a.352.352,0,0,0,.139-.689A9.067,9.067,0,0,0,9,0,9,9,0,0,0,1.936,14.577a1.477,1.477,0,1,0,1.229-.658Zm.547,2.023a.773.773,0,1,1,.227-.547A.768.768,0,0,1,3.712,15.943Zm0,0"
                    transform="translate(0)"
                    fill={content?.taskStatus?.color}
                  />
                  <path
                    id="Path_429"
                    data-name="Path 429"
                    d="M206.6,34.346a1.473,1.473,0,1,0-.52.477,8.3,8.3,0,0,1-8.18,13.236.352.352,0,1,0-.138.69,9.073,9.073,0,0,0,1.775.175A9,9,0,0,0,206.6,34.346Zm-1.776-.272a.774.774,0,1,1,.547.226A.768.768,0,0,1,204.828,34.074Zm0,0"
                    transform="translate(-190.541 -30.925)"
                    fill={content?.taskStatus?.color}
                  />
                  <path
                    id="Path_430"
                    data-name="Path 430"
                    d="M78.932,86.445a.352.352,0,0,0,.352.352h2.2a.352.352,0,0,0,.352-.352v-.682a5.505,5.505,0,0,0,1.319-.547l.481.481a.351.351,0,0,0,.5,0l1.554-1.555a.352.352,0,0,0,0-.5l-.481-.481a5.5,5.5,0,0,0,.547-1.319h.679a.352.352,0,0,0,.352-.352V79.3a.352.352,0,0,0-.352-.352h-.679a5.505,5.505,0,0,0-.547-1.319l.478-.478a.352.352,0,0,0,0-.5L84.127,75.1a.352.352,0,0,0-.5,0l-.477.477a5.5,5.5,0,0,0-1.319-.547v-.675A.352.352,0,0,0,81.482,74h-2.2a.352.352,0,0,0-.352.352v.675a5.5,5.5,0,0,0-1.319.547l-.477-.477a.352.352,0,0,0-.5,0L75.084,76.65a.351.351,0,0,0,0,.5l.478.478a5.5,5.5,0,0,0-.547,1.319h-.678a.352.352,0,0,0-.352.351v2.2a.351.351,0,0,0,.352.352h.679a5.506,5.506,0,0,0,.547,1.319l-.481.481a.352.352,0,0,0,0,.5L76.635,85.7a.352.352,0,0,0,.249.1h0a.352.352,0,0,0,.249-.1l.481-.481a5.51,5.51,0,0,0,1.319.547Zm-1.182-1.968a.352.352,0,0,0-.439.047l-.428.428-1.057-1.058.428-.428a.351.351,0,0,0,.047-.439,4.812,4.812,0,0,1-.666-1.607.352.352,0,0,0-.344-.278h-.6v-1.5h.6a.352.352,0,0,0,.344-.278,4.812,4.812,0,0,1,.666-1.607.351.351,0,0,0-.047-.439l-.425-.425,1.058-1.057.424.425a.352.352,0,0,0,.439.047,4.81,4.81,0,0,1,1.607-.666.352.352,0,0,0,.278-.344v-.6h1.5v.6a.351.351,0,0,0,.278.344,4.814,4.814,0,0,1,1.607.666.351.351,0,0,0,.439-.047l.425-.424L84.937,76.9l-.425.425a.351.351,0,0,0-.047.439,4.815,4.815,0,0,1,.666,1.607.351.351,0,0,0,.344.278h.6v1.5h-.6a.352.352,0,0,0-.344.278,4.811,4.811,0,0,1-.666,1.607.352.352,0,0,0,.047.439l.428.428-1.057,1.058-.428-.428a.351.351,0,0,0-.439-.047,4.815,4.815,0,0,1-1.607.666.352.352,0,0,0-.278.344v.607h-1.5v-.607a.352.352,0,0,0-.278-.344A4.812,4.812,0,0,1,77.751,84.477Zm0,0"
                    transform="translate(-71.384 -71.399)"
                    fill={content?.taskStatus?.color}
                  />
                  <path
                    id="Path_431"
                    data-name="Path 431"
                    d="M179.181,176.276a2.9,2.9,0,1,0-2.9,2.9A2.908,2.908,0,0,0,179.181,176.276Zm-5.107,0a2.2,2.2,0,1,1,2.2,2.2A2.2,2.2,0,0,1,174.074,176.276Zm0,0"
                    transform="translate(-167.277 -167.277)"
                    fill={content?.taskStatus?.color}
                  />
                  <path
                    id="Path_432"
                    data-name="Path 432"
                    d="M338.43,18.512a.352.352,0,1,0-.248-.1A.354.354,0,0,0,338.43,18.512Zm0,0"
                    transform="translate(-326.193 -17.183)"
                    fill={content?.taskStatus?.color}
                  />
                  <path
                    id="Path_433"
                    data-name="Path 433"
                    d="M154.711,474.359a.352.352,0,1,0,.249.1A.355.355,0,0,0,154.711,474.359Zm0,0"
                    transform="translate(-148.933 -457.683)"
                    fill={content?.taskStatus?.color}
                  />
                </g>
              </svg>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <p className="my-0">{content?.taskStatus?.name}</p>
            </div>
          </div>

          <div
            className={`d-flex justify-content-center py-2 px-3 ${styleEnd(
              "m",
              2
            )} mb-2`}
            style={{
              backgroundColor: "#F2F2F2",
              width: "fit-content",
              borderRadius: 10,
            }}
          >
            <div className={`${styleEnd("m", 2)}`}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="14.541"
                viewBox="0 0 16 14.541"
              >
                <g
                  id="Group_303"
                  data-name="Group 303"
                  transform="translate(-708 -230.459)"
                >
                  <path
                    id="Path_344"
                    data-name="Path 344"
                    d="M12.108,35a2.108,2.108,0,1,0,2.108,2.108A2.108,2.108,0,0,0,12.108,35Zm0,3.3a1.171,1.171,0,1,1,1.171-1.171A1.171,1.171,0,0,1,12.108,38.3Z"
                    transform="translate(700.57 203.164)"
                    fill={content?.priority?.color}
                  />
                  <path
                    id="Path_345"
                    data-name="Path 345"
                    d="M9.529,5A6.436,6.436,0,0,0,3.1,11.246l-.582-.417a.5.5,0,0,0-.645.052L.852,11.906A.5.5,0,0,0,.8,12.55l.5.712-.055.135-.867.145a.5.5,0,0,0-.417.5v1.444a.5.5,0,0,0,.417.5l.867.145.055.135-.5.712a.5.5,0,0,0,.052.645l1.024,1.024a.5.5,0,0,0,.645.052l.715-.5.132.055.145.869a.5.5,0,0,0,.5.417H5.456a.5.5,0,0,0,.5-.417l.145-.869.132-.055.715.5a.5.5,0,0,0,.645-.052l.847-.879A6.43,6.43,0,1,0,9.529,5ZM7.158,16.588,7.6,17.2l-.422.422-.612-.437a.5.5,0,0,0-.532-.035,2.683,2.683,0,0,1-.535.225.5.5,0,0,0-.345.395l-.125.75H4.43l-.125-.75a.5.5,0,0,0-.337-.395,2.683,2.683,0,0,1-.535-.225.5.5,0,0,0-.532.035l-.62.437L1.859,17.2l.437-.612a.5.5,0,0,0,.032-.535,2.581,2.581,0,0,1-.22-.527.5.5,0,0,0-.39-.35l-.75-.125v-.595l.75-.125a.5.5,0,0,0,.39-.337,2.581,2.581,0,0,1,.22-.527.5.5,0,0,0-.032-.535l-.437-.625.422-.422.612.437a.5.5,0,0,0,.535.032,2.581,2.581,0,0,1,.54-.22.5.5,0,0,0,.337-.39L4.43,11h.595l.125.75a.5.5,0,0,0,.35.4,2.581,2.581,0,0,1,.527.22.5.5,0,0,0,.535-.032l.612-.437.422.422-.437.6a.5.5,0,0,0-.035.532,2.683,2.683,0,0,1,.225.535.5.5,0,0,0,.395.345l.75.125v.595l-.75.125a.5.5,0,0,0-.395.345,2.683,2.683,0,0,1-.225.535.5.5,0,0,0,.035.532Zm2.371.275a5.5,5.5,0,0,1-1.014-.1l-.372-.522c.02-.042.037-.087.055-.132l.869-.145a.5.5,0,0,0,.417-.5V14.032a.5.5,0,0,0-.417-.5L8.2,13.387c-.017-.045-.035-.09-.055-.132l.5-.715a.5.5,0,0,0-.052-.645L7.565,10.871a.5.5,0,0,0-.645-.052l-.712.5-.135-.055L5.929,10.4a.5.5,0,0,0-.5-.417H4.29a5.432,5.432,0,1,1,5.247,6.866Z"
                    transform="translate(708.04 225.459)"
                    fill={content?.priority?.color}
                  />
                  <path
                    id="Path_346"
                    data-name="Path 346"
                    d="M37.2,15.108V11.048a.468.468,0,0,0-.937,0V15.3a.468.468,0,0,0,.138.33L38.2,17.438a.47.47,0,0,0,.661-.67Z"
                    transform="translate(680.936 221.186)"
                    fill={content?.priority?.color}
                  />
                </g>
              </svg>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <p className="my-0">{content?.priority?.name}</p>
            </div>
          </div>

          <Link
            className="d-flex justify-content-center py-2 px-3 mb-2 text-decoration-none text-dark"
            style={{
              backgroundColor: "#F2F2F2",
              width: "fit-content",
              borderRadius: 10,
            }}
            to={`/taskDetails/${content.id}`}
          >
            <div className="hoverLinks d-flex">
              <div
                className={`d-flex justify-content-center align-items-center ${styleEnd(
                  "m",
                  2
                )}`}
                style={{
                  border: "1px solid #1A73E8",
                  borderRadius: "50%",
                  width: 24,
                  height: 24,
                  fontSize: 12,
                }}
              >
                {content.procedureCount}
              </div>
              <div className="d-flex align-items-center justify-content-center">
                <p className="my-0">
                  {content.procedureCount > 1
                    ? Lang.procedures
                    : Lang.procedure}
                </p>
              </div>
            </div>
          </Link>
        </div>

        {/* description */}
        <div className="d-flex flex-column flex-wrap px-4 py-2">
          <div>
            <p className="mt-4 fw-bold">{Lang.Description}</p>
          </div>
          <div>
            <p>{content.description}</p>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DetailsPopup;
